import React from 'react';
import purebem from 'purebem';

import type {
    FoundationTextboxIconSymbolProps,
} from './types';

import './FoundationTextboxIconSymbol.scss';


function FoundationTextboxIconSymbol({
    icon,
}: FoundationTextboxIconSymbolProps): React.ReactElement {
    const block = purebem('foundation-textbox-icon-symbol');
    return (
        <span className={ purebem.many(block(), `bi-${icon}`) } />
    );
}

export default FoundationTextboxIconSymbol;
